module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_banner03-3f0de244ec4688d304443d7379902f22.jpg";